export const getAdvisorErrorMessage = (error, fallback) => {
  const messages = [
    error,
    error && error.message,
    error && error.message && error.message.error,
    error && error.message && error.message.message,
    error && error.error,
  ];
  return (
    messages.find((message) => typeof message === 'string' && message.trim()) ||
    fallback
  );
};
